import type { SearchContainerResult } from './types';

export type SearchNavigationTarget = Pick<
  SearchContainerResult,
  'containerId' | 'containerType' | 'topBlockId'
>;

export function searchTargetHref(
  target: SearchNavigationTarget,
  options?: { query?: string; blockId?: string },
): string {
  const params = new URLSearchParams();
  const query = options?.query?.trim();
  if (query) {
    params.set('q', query);
  }
  const blockId = options?.blockId ?? target.topBlockId;
  if (blockId) {
    params.set('block', blockId);
  }
  const search = params.toString();
  const suffix = search ? `?${search}` : '';

  if (target.containerType === 'database') {
    return `/search/database/${target.containerId}${suffix}`;
  }
  return `/search/page/${target.containerId}${suffix}`;
}
